function chainPropTypes(propType1, propType2) {
  return process.env.NODE_ENV === "production" ? () => null : function(...args) {
    return propType1(...args) || propType2(...args);
  };
}
export {
  chainPropTypes as default
};
//# sourceMappingURL=chainPropTypes.js.map
